module.exports = __webpack_public_path__ + "static/media/Hover4.0dc4be63.svg";